import React, { useEffect, useMemo } from 'react';
import {useNewUITranslation, AdminPageNav, ConfirmDialog, managerTableKeepGlobalData, showSnackbar, useSelectedAdminDrawer} from '@tuqqi/web'
import { isJsonValid, parseImageUrl, TemplateType, userService } from '@tuqqi/common';
import JSON5 from 'json5'

import { JsonEditor, themes } from 'json-edit-react'
import useUndo from 'use-undo'
import { ADMIN_OPTION_SUB_DIV } from './getOptionFromPath';
import { withStyles } from '@material-ui/core';
import withErrorCatcher from '../../../components/Common/withErrorCatcher';
import { compose } from 'recompose';
import { connect } from 'react-redux';

const CONTENT_OFFSET = 16 + 48 + 2;
const PAGE_WIDTH = 700;
const UIdefaultToolbarHeight = 48;
const top = 8;

const styles = {
    field: {
        marginBottom: 24,
        marginTop: -6,
        marginRight: -8,
        marginLeft: -8,
    },
	container: {
		height: `calc(100vh - ${UIdefaultToolbarHeight + top}px)`,
		overflowX: 'hidden',
		maxWidth: 1000 + CONTENT_OFFSET,
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		marginRight: 'auto',
		marginLeft: 'auto',
		backgroundColor: '#F9F9F9',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
    },
	header: {
		marginTop: 20,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	avatar: {
		minWidth: 36,		
		width: 36,		
		height: 36,
		borderRadius: '50%',
        objectFit: 'cover'
	},
	updateBtn: {
		cursor: 'pointer',
		display: 'flex',
		padding: '6px 12px',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 6,
		background: '#fff',
		border: '1px solid #6366F1'
	},
	updateBtnText: {
		color: '#6366F1',
		textAlign: 'center',
		fontFamily: 'Rubik',
		fontSize: 12,
		fontStyle: 'normal',
		fontWeight: 500,
		lineHeight: '16px',
		marginLeft: 8
	},
    fieldWide: {
        marginBottom: 24,
        marginTop: -6,
        marginRight: 0,
        marginLeft: 0,
    },
	title: {
		marginTop: 16,
		color: '#18181B',
		textAlign: 'left',
		fontFamily: 'Rubik',
		fontSize: 24,
		fontStyle: 'normal',
		fontWeight: 500,
		lineHeight: '32px',
	},
	brief: {
		marginTop: 4,
		color: '#6B6F7A',
		textAlign: 'left',
		fontFamily: 'Rubik',
		fontSize: 16,
		fontStyle: 'normal',
		fontWeight: 400,
		lineHeight: '24px',
	},
	description: {
		marginTop: 24,
		fontFamily: 'Rubik',
	},
    disabledBtn : {
        pointerEvents: 'none',
        opacity: 0.5
    },
    editor: {
        backgroundColor: '#fff!important',
        marginTop: 24,
        fontFamily: 'Rubik!important',
        "& .jer-editor-container": {
            backgroundColor: '#fff!important'
        },
        "& .jer-collection-text-area": {
            width: '636px!important',
            minHeight: '70vh',
        }
    }
};

const fallbackImage = '/resources/group_placeholder.png'
const parseLink = (link, cloudfront) => {
    if(!link || !cloudfront) return fallbackImage
    return parseImageUrl(cloudfront)(link) || fallbackImage
}

const defaultNewValue = ''

const UID_WRAP1 = 'view_template_view_wrap_drawer'

// const mock = {
// 	"name": null,
// 	"authorID": null,
// 	"createdOn": "0001-01-01T00:00:00Z",
// 	"publicDocuments": null,
// 	"groups": [
// 	  {
// 		"title": "V4.6",
// 		"description": "Version 4.6, 17.03 - 14.04 \n(dedicated to the new previews of all items - web & app)",
// 		"icon": "public",
// 		"backgroundUrl": "fileId=8E0AA65C17284CAF86E7737E9F4940D1_21531192.jpg",
// 		"availableViews": "home;chat;feed;kanban;table;calendar;scheduler;dashboard",
// 		"defaultView": "kanban",
// 		"allowedInputs": [],
// 		"allInputsAllowed": true,
// 		"daysToAlertOnUnusedItem": 0,
// 		"isLimitedGroupEnabled": false,
// 		"isClosed": false,
// 		"isEnableMembersAsAuthors": false,
// 		"collectionFeedUpdateType": 0,
// 		"documentTemplates": [],
// 		"labels": [],
// 		"ganttLanes": [],
// 		"lanes": [
// 		  {
// 			"title": "Pipeline",
// 			"description": null,
// 			"order": 0,
// 			"listColor": 0,
// 			"items": []
// 		  },
// 		  {
// 			"title": "On going",
// 			"description": null,
// 			"order": 1,
// 			"listColor": 0,
// 			"items": []
// 		  },
// 		  {
// 			"title": "QA",
// 			"description": null,
// 			"order": 2,
// 			"listColor": 0,
// 			"items": []
// 		  },
// 		  {
// 			"title": "Done",
// 			"description": null,
// 			"order": 3,
// 			"listColor": 0,
// 			"items": []
// 		  },
// 		  {
// 			"title": "Relevant docs",
// 			"description": null,
// 			"order": 4,
// 			"listColor": 0,
// 			"items": []
// 		  },
// 		  {
// 			"title": "Not completed/postponed",
// 			"description": null,
// 			"order": 5,
// 			"listColor": 0,
// 			"items": []
// 		  }
// 		],
// 		"collectionAvailabilityTimes": null,
// 		"groupArticle": null,
// 		"groupDefaultStatusColor": 0,
// 		"newColumnTitle": null,
// 		"newGanttTitle": null
// 	  }
// 	],
// 	"customInputs": []
//   }


 const _EditJSONTemplate = (props) => {
	const [t] = useNewUITranslation('i18_admin');

    const {templates, orgName, classes, dispatch} = props
    const cloudfront = managerTableKeepGlobalData.getCloudfront()


    const [
        { present: data },
        { set: setData },
      ] = useUndo({})

    const {uid: _uid} = useSelectedAdminDrawer(UID_WRAP1)
    

    const parts = _uid.split(ADMIN_OPTION_SUB_DIV)
    const uid = parts?.[parts.length - 1] ?? ''

    const template = useMemo(() => {
        if(!uid) return undefined
        return templates.find(x => x.id + '' === uid)
    }, [templates, uid])

	const link = useMemo(() => {
		const imageLink = parseLink(template?.pictureUrl ?? '', cloudfront)
		return imageLink
	}, [template?.pictureUrl, cloudfront])

	const allowUpdate = template && template.templateType === TemplateType.PrivatePerOrganization


	const onUpdate = () => {
        if(!template?.id) return
		if(!allowUpdate) return

		try {
		const json = JSON.stringify(data)
		if(!isJsonValid(json)) {
			dispatch(showSnackbar("Error editing json"))
			return
		}
		userService.updateTemplateJSON(template.id, {json}).then(res => {
			if(!res) return
			dispatch(showSnackbar("Template JSON updated"))
	
		})
		} catch (error) {
			dispatch(showSnackbar("Error editing json"))
		}
    }

	useEffect(() => {
		if(!template?.id) return
		userService.getTemplateJSON(template.id).then(res => {
			if(!res.val) {
				setData(res.val)
				// setData(mock)
				return;
			}
			setData(res.val)
		})
	}, [template?.id])



    if(!template) return null


	const UpdateBtn = <div className={`${classes.updateBtn} ${!allowUpdate ? classes.disabledBtn : ''}`}>
		<div className={classes.updateBtnText}>{t("Update Template")}</div>
	</div>

	const Icon = <div>
		<img src={link} alt='img' className={classes.avatar} />
	</div>

    const Editor = <div>
        <JsonEditor
            data={data}
            setData={setData}
            rootName={"templateJSON"}
            theme={['default', { container: { paddingTop: '1em' } }]}
            indent={2}
            onError={(errorData) => {
                dispatch(showSnackbar("Error editing json"))
            }}
            showErrorMessages
            collapse={2}
            collapseAnimationTime={300}
            showCollectionCount={'when-closed'}
            enableClipboard={({ type }) => {
                dispatch(showSnackbar(`${type === 'value' ? 'Value' : 'Path'} copied to clipboard`))
            }}
            restrictEdit={false}
            restrictDelete={false}
            restrictAdd={false}
            restrictDrag={true}
            defaultValue={defaultNewValue}
            showArrayIndices={true}
            showStringQuotes={true}
            minWidth={'min(500px, 95vw)'}
            maxWidth="min(670px, 90vw)"
            className={`block-shadow ${classes.editor}`}
            stringTruncate={90}
            jsonParse={JSON5.parse}
            />
    </div>


	const Header = <div className={classes.header}>
		{Icon}
		{<ConfirmDialog title={t(`Update template`)}
        keysManager
        stopBubling
        stopBublingKeys
        message={t(`Are you sure you want to change this template? If you confirm, everybody in {{orgName}} will be able to use it`, {orgName: orgName})}
        actionButtonText={t("Update")}
        onConfirmed={(resolve) => { onUpdate(); resolve() }}>
            {UpdateBtn}
    </ConfirmDialog>}
	</div>

	return (
		<div className={classes.container}>
			<div className={classes.content}>
				<AdminPageNav pageWidth={PAGE_WIDTH} rootTitle={t('Customization')} pageTitle={t('Templates')} subTitle={template.title} />
				{Header}
				{Editor}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
    orgName: state.data?.userData?.userDetails?.data?.org?.title ?? 'System',
    templates: state.data?.globalData?.templates?.templates ?? [],
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch: dispatch,
    }
}
export const EditJSONTemplate = compose(
    withStyles(styles),
    withErrorCatcher(),
    connect(mapStateToProps,mapDispatchToProps)
)(_EditJSONTemplate);
